import React, { useEffect, useState } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import get from 'lodash/get';
import Title from '../../../components/atoms/Title';
import useStyles from './style';
import Typography from '../../../components/atoms/Typography';
import CustomTabs from '../../../components/molecules/Tabs';
import Picture from '../../../components/atoms/Picture';
import FlightsForm from './FlightsForm';
import HotelForm from './HotelForm';
import validate from '../../../utils/validationRules';
import Container from '../../../components/molecules/Container';
import Grid from '../../../components/molecules/Grid';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import { DATE_TEXT } from './FlightsForm/Constants';
import { FLIGHTS_FORM, HOTEL_FORM } from './constants';
import { COMPONENT_NAME } from './locators';
import { useMediaQuery } from '@material-ui/core';
import { canUseDOM } from '../../../utils/canUseDOM';
import {
  getPageName,
  getComponentName,
} from '../../../utils/getPageComponentInfo';
import { breakpoints } from '../../../../styles/themes/vad/constants';
import checkEmptyObject from '../../../utils/checkEmptyObject';

const aspectRatio = { mobile: '4x5', desktop: '4x5' };

const renderImages = (image, className, title) => {
  return <Picture media={{ image, aspectRatio }} isParalax={true} className={className} alternateAltText={title && title.value} />;
};

const renderTabsWithForm = (
  tabList = [],
  classes,
  pageName,
  componentName,
  appConfig
) => {
  const tabsData = tabList.map((tab, index) => {
    const { fields, tabText, widgetForm, key, formType } = tab.fields;
    return {
      data: renderForm(
        fields,
        tabText,
        key,
        widgetForm,
        index,
        classes,
        pageName,
        componentName,
        appConfig,
        formType
      ),
      label: tabText && tabText.value,
    };
  });

  return <CustomTabs tabs={tabsData} className={`${classes.tabRoot} pills-tabs-container`} />;
};

const validateForm = (rules, payload) => {
  let error = {};
  for (let rule of rules) {
    const isValid = validate(payload[rule.fieldName], rule.rules);
    if (!isValid) {
      error[rule.fieldName] = !isValid;
    }
  }
  return error;
};

const renderForm = (
  formData,
  tabText,
  key,
  widgetForm,
  index,
  classes,
  pageName,
  componentName,
  appConfig,
  formType
) => {
  formData =
    formData &&
    formData.map(data => {
      if (get(data, 'fields.fieldType.value') === DATE_TEXT) {
        data.fields.dateReturnLabel = data.fields.fieldLabel.value;
      }
      return data;
    });

  return (
    <div key={index}>
      {key && key.value === FLIGHTS_FORM && (
        <FlightsForm
          formData={formData}
          currentTab={tabText}
          classes={classes}
          validateForm={validateForm}
          pageName={pageName}
          componentName={componentName}
          appConfig={appConfig}
          formType={formType}
        />
      )}
      {key && key.value === HOTEL_FORM && (
        <HotelForm
          formData={formData}
          currentTab={tabText}
          classes={classes}
          widgetForm={widgetForm}
          validateForm={validateForm}
          pageName={pageName}
          componentName={componentName}
          appConfig={appConfig}
          formType={formType}
        />
      )}
    </div>
  );
};

const TabsWithForm = props => {
  const classes = useStyles(props);
  const isFieldsEmpty = checkEmptyObject(props.fields);

  const { sectionText, belowImage, upperImage, tabList, title } = props.fields;
  const [minHeightCalculated, setMinHeightCalculated] = useState('auto');
  const isMobile = useMediaQuery(`(max-width:${breakpoints.values.lg}px)`);

  useEffect(() => {
    setTimeout(() => {
      if (canUseDOM && document.querySelector('#tabswithform-tabs')) {
        setMinHeightCalculated(
          `${document.querySelector('#tabswithform-tabs').offsetHeight}px`
        );
      }
    }, 100);
  }, []);

  return (
    isFieldsEmpty ? <></> :
      <div className={classes.wrapper} data-locator={COMPONENT_NAME}>
        <Grid>
          <Grid container className={classes.mainContent} >
            <div className={classes.contentSection}>
              {sectionText && sectionText.value &&
                <Title text={sectionText} />
              }
              <Typography
                variant="h2"
                component="h2"
                gutterBottom={false}
                className={classes.heading}
                wordBreak
              >
                <Text field={title} />
              </Typography>
              <div
                id="tabswithform-tabs"
                style={{ minHeight: isMobile ? 'auto' : minHeightCalculated }}
              >
                {renderTabsWithForm(
                  tabList,
                  classes,
                  getPageName(props),
                  getComponentName(props),
                  props.appConfig
                )}
              </div>
            </div>
            <div className={classes.imageSection}>
              {upperImage && upperImage.value && upperImage.value.src &&
                renderImages(upperImage, 'image-above', title)
              }
              {renderImages(belowImage, 'image-below', title)}
            </div>
          </Grid>
        </Grid>
      </div>
  );
};

export default withErrorBoundary(
  withSitecoreContext()(withNamespaces()(TabsWithForm))
);
